import React, {useState} from "react";
import t, {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {useSelector} from "react-redux";
import {GetCurrentLocale, SelectInterface, pathname} from "../../components/Utils";
import {RootState} from "../../app/RootReducer";
import {allStepForStepsForm} from "../../components/UtilsForCart";
import HaveAnAccountBlock from "../../components/HaveAnAccountBlock";
import MultiStepsForm from "../User/Account/MultiStepsForm";


const CartPageContainer = () => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)

  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);
  const [remarqueText, setRemarqueText] = useState("")
  const [selectedServices, setSelectedServices] =  useState<SelectInterface|null>(null);
  let isCartPage = false
  if(pathname === "/" + locale + t('url_cart')){
    isCartPage = true
  }

  const [activeStep, setActiveStep] = useState(0)

  const allSteps =
    [
      {
        "id": "cart",
        "label": t('cart'),
        "icon" : "/images/who.png",
        "showIfAuthenticated" : true,
        "step" : 0,
      },
      {
        "id": "infos",
        "label": t('infos'),
        "icon" : "/images/id-card.png",
        "showIfAuthenticated" : false,
        "step" : 1,
      },
      {
        "id": "summary",
        "label": t('summary'),
        "icon" : "/images/id-card.png",
        "showIfAuthenticated" : true,
        "step" : 2,
      },
      {
        "id": "confirmation",
        "label": t('confirmation'),
        "icon" : "/images/success.png",
        "showIfAuthenticated" : true,
        "step" : 3,
      },
    ]

  const stepsIfUserIsConnected = allSteps.filter((a) => a.showIfAuthenticated)

  return (
      isAuthenticated ?
        <div className="bg-circle-bottom container-create-account py-5">
          <div className="container pb-5 mb-5">
            <div className="mb-5">
              <div className="card-body p-0">
                <div className="progress-bar" id="topPage">
                  {
                    allStepForStepsForm(isAuthenticated ? stepsIfUserIsConnected : allSteps, activeStep)
                  }
                </div>
                <div className="form-outer">
                  <MultiStepsForm
                    isCreateAccount={false}
                    isEditForm={false}
                    isCartPage={true}
                    setActiveStep={setActiveStep}
                    activeStep={activeStep}
                    remarkText={remarqueText}
                    setRemarqueText={setRemarqueText}
                    selectedServices={selectedServices}
                    setSelectedServices={setSelectedServices}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      :
     <div className="container">
       <div className="row">
         <div className="col-md-12">
           <HaveAnAccountBlock/>
         </div>
       </div>
     </div>
  )
}

export default CartPageContainer;
